import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Button,
} from 'react-bootstrap';
import { generate } from 'shortid';
import { format as phoneFormat } from 'libphonenumber-js';

// field group
import FieldGroup from '../FieldGroup/FieldGroup';
import DoorOpenNumberField from '../FieldGroup/DoorOpenNumberField';
import AddressField from '../FieldGroup/AddressField';
// validations
import {
  PropertyFormValidation,
} from '../../tools/Validations';

export const PropertyFormType = {
  New: "NEW",
  Edit: "EDIT",
}

const PropertyForm = observer(
class PropertyForm extends Component {
  constructor(props) {
    super(props);
    let {
      validation = new PropertyFormValidation(),
      property,
    } = props;

    this.ids = {
      name: generate(),
      twilioNumber: generate(),
      doorOpenNumber: generate(),
    };

    this.formValidation = validation;
    this.formValidation.test(property);
    this.state = { disableSaveButton: false };
  }

  render() {
    let {
      formType = PropertyFormType.New,
      property,
      showSaveButton = false,
    } = this.props;
    const disableSaveButton = this.state.disableSaveButton || !this.formValidation.passAllValidations();

    return (
      <form onSubmit={this.onSave}>
        <FieldGroup
          focus
          id={this.ids.name}
          name="name"
          type="text"
          label="Property name"
          value={property.name}
          placeholder="e.g. My home"
          validation={this.formValidation.name}
          onChange={this.handleChange} />
        <DoorOpenNumberField
          validation={this.formValidation.doorOpenNumber}
          onChange={this.handleChange}
          value={property.doorOpenNumber} />
        {
          formType === PropertyFormType.New ?
            this.renderForNew(property) :
            this.renderForEdit(property)
        }
        <div style={{display: showSaveButton ? "" : "none"}}>
          <Button
            type="submit"
            hidden={showSaveButton}
            disabled={disableSaveButton}
            bsStyle="primary">Save</Button>
        </div>
      </form>
    );
  }

  renderForEdit = (property) => {
    return (
      <FieldGroup
        id={this.ids.twilioNumber}
        name="twilioNumber"
        type="text"
        label="Passcode phone number"
        placeholder="(604) 123-4567"
        help="Give this number to your building manager to set as your intercom contact number."
        value={phoneFormat(property.twilioNumber, "US", "National")}
        disabled />
    );
  }

  renderForNew = (property) => {
    return (
      <AddressField
        validation={this.formValidation.address}
        value={property.address}
        onChange={this.handleChange} />
    )
  }

  handleChange = (e, isValid = false) => {
    e.preventDefault();

    let { name, value } = e.target;
    let data = {};
    data[name] = String(value);
    this.props.property.set(data);
    this.formValidation.test(this.props.property);

    return false;
  }

  onSave = (e) => {
    e.preventDefault();
    this.disableSaveButton();
    let { onSave, property } = this.props;
    if (onSave && this.formValidation.passAllValidations()) {
      onSave(property);
    }
    this.disableSaveButton(false);
    return false;
  }

  disableSaveButton = (bDisable = true) => {
    this.setState({ disableSaveButton: bDisable });
  }
});

export default PropertyForm;


// WEBPACK FOOTER //
// ./src/components/Property/PropertyForm.js